import { faLeaf } from "@fortawesome/pro-regular-svg-icons"
import { S_DesktopOnly } from "component/micro/responsive/responsive"
import { PageWrapper } from "component/pageWrapper/PageWrapper"
import { MadeInNorway } from "component/w24/component/MadeInNorway"
import { SplitTitle } from "component/w24/component/SplitTitle"
import { Benefits } from "component/w24/layout/Benefits"
import { HeaderMenu } from "component/w24/layout/HeaderMenu"
import { LandingFooter } from "component/w24/layout/LandingFooter"
import { LandingHeader } from "component/w24/layout/LandingHeader"
import { MapDemo } from "component/w24/layout/MapDemo"
import { PCScreen } from "component/w24/layout/PCScreen"
import { BlackIconBox } from "component/w24/structure/BlackIconBox"
import { ContactForm } from "component/w24/structure/ContactForm"
import { Countries } from "component/w24/structure/Countries"
import { FAQ } from "component/w24/structure/FAQ"
import { FooterDetails } from "component/w24/structure/FooterDetails"
import { GreyPhotoBox } from "component/w24/structure/GreyPersonBox"
import { LogosDemo } from "component/w24/structure/LogosDemo"
import { MapShowcase } from "component/w24/structure/MapShowcase"
import { SVG_Logo } from "libs/images/w24/SVG_Logo"
import { Localization } from "libs/localization/localization"
import { EColors } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React, { useEffect, useState } from "react"
import { Link as Link2 } from "react-scroll"
import styled from "styled-components/macro"

export const HomePage = (): JSX.Element => {
  const isWide = useIsWide()
  const [selectedItem, setSelectedItem] = useState<string | null>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setSelectedItem(entry.target.id)
          }
        })
      },
      { threshold: 0.9 }
    )

    const aboutSection = document.getElementById("about")
    const mapSection = document.getElementById("map")
    const faqSection = document.getElementById("faq")
    const contactSection = document.getElementById("contact")
    const partnersSection = document.getElementById("partners")
    const trondheimSection = document.getElementById("trondheim")

    if (aboutSection) observer.observe(aboutSection)
    if (mapSection) observer.observe(mapSection)
    if (faqSection) observer.observe(faqSection)
    if (contactSection) observer.observe(contactSection)
    if (partnersSection) observer.observe(partnersSection)
    if (trondheimSection) observer.observe(trondheimSection)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <PageWrapper>
      <S_HomePage>
        {/* Menu */}
        <S_DesktopOnly>
          <S_HeaderMenu selectedItem={selectedItem} />
        </S_DesktopOnly>
        <S_PCScreen>
          {/* Mobile header */}
          <S_Header>
            <SVG_Logo />
            {/* <LinkItem
              title={Localization.ADMIN_CALL}
              link="https://app.mapheim.com/admin"
            /> */}
          </S_Header>

          {/* About */}
          <S_WrapId id="about">
            <S_LandingHeader />
          </S_WrapId>
          <S_Benefits />
          <S_BlackIconBox
            icon={faLeaf}
            title={Localization.ECO1}
            description={Localization.ECO1_DESC}
          />

          {/* Map */}
          <S_WrapId id="map">
            <S_SplitTitle title={Localization.MAP_TITLE}>
              {Localization.MAP_DESC} <br />
              {Localization.MAP_DESC2}
            </S_SplitTitle>
            <MapShowcase />
          </S_WrapId>

          {/* FAQ */}
          <S_WrapId id="faq">
            <S_SplitTitle
              title={
                isWide
                  ? Localization.FREQUENTLY_ASKED_QUESTIONS
                  : Localization.FAQ
              }
            >
              {Localization.FAQ_DESC1}
              <br /> {Localization.FAQ_DESC2}
            </S_SplitTitle>
            <S_FAQ
              topics={[
                {
                  q: Localization.Q1,
                  a: Localization.A1,
                },
                {
                  q: Localization.Q5,
                  a: Localization.A5,
                },
                {
                  q: Localization.Q2,
                  a: Localization.A2,
                },
                {
                  q: Localization.Q3,
                  a: Localization.A3,
                },

                {
                  q: Localization.Q4,
                  a: Localization.A4,
                },
              ]}
            />
          </S_WrapId>

          {/* Contact */}
          <S_WrapId id="contact">
            <S_SplitTitle title={Localization.CONTACT_TITLE} />
            <S_ContactPart>
              <S_GreyPhotoBox
                title={Localization.CONTACT_HELLO}
                description={Localization.CONTACT_DESC}
              />
              <S_ContactForm />
            </S_ContactPart>
          </S_WrapId>

          {/* Customers */}
          <S_SplitTitle title={Localization.CUSTOMERS_TITLE} />
          <Link2
            to="contact"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <S_Countries />
          </Link2>

          {/* Partners */}
          <S_WrapId id="partners">
            <S_SplitTitle title={Localization.PARTNERS_TITLE} />
            <S_LogosDemo />
          </S_WrapId>

          {/* Trondheim */}
          <S_WrapId id="trondheim">
            <S_SplitTitle title={Localization.TRONDHEIM_ON_MAP} />
            <S_TrondheimDemo
              map="/map5.jpg"
              url="https://trondheim.io/?image=1"
            />
          </S_WrapId>

          {/* Footer */}
          <S_LandingFooter />
          <S_MadeInNorway />
          <S_FooterDetails />
          {/* <S_Menu>
          <MobileMenu
            items={[
              {
                title: "Home",
                icon: faHouse,
              },
              {
                title: "Map",
                icon: faLocationDot,
              },
              {
                title: "FAQ",
                icon: faQuestionCircle,
              },
              {
                title: "Contact",
                icon: faPaperPlane,
              },
              {
                title: "Partners",
                icon: faShareAlt,
              },
            ]}
          />
        </S_Menu> */}
        </S_PCScreen>
      </S_HomePage>
    </PageWrapper>
  )
}

const S_HomePage = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${EColors.GREY1};
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  @media only screen and (min-width: 1260px) {
    margin: auto;
    max-width: 1920px;
  }
`

const S_PCScreen = styled(PCScreen)`
  display: flex;
  flex-direction: column;
`

const S_HeaderMenu = styled(HeaderMenu)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
`

const S_Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 72px;
  align-items: center;
  padding: 0 20px 0 15px;
  @media only screen and (min-width: 1260px) {
    height: 64px;
    padding: 0 20px 0 15px;
  }
`

const S_LandingHeader = styled(LandingHeader)`
  margin: 0 0 167px 0;
  @media only screen and (min-width: 1260px) {
    margin: 80px 0 100px 0;
  }
`

const S_Benefits = styled(Benefits)`
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  @media only screen and (min-width: 1260px) {
    overflow-x: hidden;
  }
`

const S_BlackIconBox = styled(BlackIconBox)`
  margin: 20px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 60px 0 0 0;
  }
`

const S_SplitTitle = styled(SplitTitle)`
  margin: 60px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 0;
  }
`

const S_FAQ = styled(FAQ)`
  margin: 35px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 60px 0 0 0;
  }
`

const S_ContactPart = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 1260px) {
    flex-direction: row;
    gap: 60px;
  }
`

const S_GreyPhotoBox = styled(GreyPhotoBox)`
  margin: 20px 0 0 0;
  flex-shrink: 0;
  @media only screen and (min-width: 1260px) {
    margin: 60px 0 0 0;
  }
`

const S_ContactForm = styled(ContactForm)`
  margin: 20px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 60px 0 0 0;
  }
`

const S_Countries = styled(Countries)`
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 37px 0 0 0;
  @media only screen and (min-width: 1260px) {
    overflow-x: hidden;
    justify-content: center;
  }
`

const S_LogosDemo = styled(LogosDemo)`
  margin: 25px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 60px 0 0 0;
  }
`

const S_TrondheimDemo = styled(MapDemo)`
  margin: 50px 0 0 0;
`

const S_LandingFooter = styled(LandingFooter)`
  margin: 60px 0 0 0;
`

const S_MadeInNorway = styled(MadeInNorway)`
  margin: 60px 0 60px 0;
  width: 100%;
  justify-content: center;
`

const S_WrapId = styled.div`
  display: flex;
  flex-direction: column;
`

const S_FooterDetails = styled(FooterDetails)``

// const S_Menu = styled.div`
//   position: fixed;
//   bottom: -5px;
//   left: -5px;
//   width: 100%;
//   padding: 5px;
//   box-sizing: border-box;
// `

export default HomePage
